function getDateOfBirth(age: number): string {
  const timezoneOffset = '+08:00';

  const currentDate = new Date();

  const birthYear = currentDate.getFullYear() - age;

  const birthDate = new Date(currentDate);
  birthDate.setFullYear(birthYear);

  const year = birthDate.getFullYear();
  const month = String(birthDate.getMonth() + 1).padStart(2, '0');
  const day = String(birthDate.getDate()).padStart(2, '0');
  const hours = '00';
  const minutes = '00';
  const seconds = '00';

  const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${timezoneOffset}`;

  return formattedDate;
}

// Carriers whose plans have no live pricing for part of the model catalogue
// (e.g. GE does not underwrite Porsche). For those the premiums API returns no
// price at all, and clicking out to the carrier site only gets the customer
// rejected there — so the card offers a broker-assisted "Chat for Quote"
// instead (INS-6577). A live price, with or without a manual-underwriting flag,
// keeps the normal click-out journey.
const CHAT_FOR_QUOTE_CARRIER_CODES: string[] = ['GEX'];

function isChatForQuoteCarrier(productTitle: string | undefined): boolean {
  // SingSaver CI product titles are `<country>.<vertical>.<carrier>.<plan>`,
  // e.g. `SG.CI.GEX.GREAT-EV-PROTECT`.
  const carrierCode = productTitle?.split('.')[2];
  return !!carrierCode && CHAT_FOR_QUOTE_CARRIER_CODES.includes(carrierCode);
}

export { getDateOfBirth, isChatForQuoteCarrier };
